import PrivacyPolicy from '../../components/privacy-policy';

export default PrivacyPolicy;
